@if ((user | avatarType) === 'image') {
<img [src]="user | avatar : tempName" alt="" />
} @else {
<div class="avatar" [innerHTML]="sanitization.bypassSecurityTrustHtml(user | avatar : tempName)"></div>
}
